/**
 * KAN-976: кошелёк кабинета.
 *
 *   GET  /api/v1/billing/wallet/          - остаток и границы пополнения
 *   GET  /api/v1/billing/wallet/entries/  - журнал операций (kind, telegram_account_id, page)
 *   POST /api/v1/billing/wallet/topup/    - платёж на пополнение, ответ с confirmation_url
 */
import apiClient from './client';
import type {
  Wallet,
  WalletEntriesPage,
  WalletEntriesParams,
  WalletTopupResponse,
} from '@/types/wallet';

const BASE = '/api/v1/billing/wallet/';

export const walletApi = {
  getWallet: async (): Promise<Wallet> => (await apiClient.get<Wallet>(BASE)).data,
  getWalletEntries: async (params: WalletEntriesParams): Promise<WalletEntriesPage> =>
    (await apiClient.get<WalletEntriesPage>(`${BASE}entries/`, { params })).data,
  /** amount строкой с двумя знаками ("1000.00"): деньги по контракту строками. */
  startTopup: async (amount: string): Promise<WalletTopupResponse> =>
    (await apiClient.post<WalletTopupResponse>(`${BASE}topup/`, { amount })).data,
};

export default walletApi;
